import { useCreateRuleToast } from '@/components/cashflow/useCreateRuleToast';
import { useToasts } from '@/components/common/Toasts';
import { useTracking } from '@/services/analytics/useTracking';
import {
    CashflowTransactionEntry,
    useBaseUpdateTransactionEntry,
} from '@common/react/cashflow';
import { TOASTS } from '@common/toasts';

const useUpdateTransactionEntry = (
    transactionEntry: CashflowTransactionEntry
) => {
    const showCreateRuleToast = useCreateRuleToast();
    const { showErrorToast } = useToasts();

    const { track } = useTracking();

    return useBaseUpdateTransactionEntry({
        transactionEntry,
        showCreateRuleToast,
        track,
        showError: () => {
            showErrorToast(TOASTS.updateTransactionEntryError);
        },
    });
};

export default useUpdateTransactionEntry;
